import { render, staticRenderFns } from "./RequestInformationPopup.vue?vue&type=template&id=ff1504aa&"
import script from "./RequestInformationPopup.vue?vue&type=script&lang=js&"
export * from "./RequestInformationPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports